var cilBookmark = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M424,496H388.75L256.008,381.19,123.467,496H88V16H424ZM120,48V456.667l135.992-117.8L392,456.5V48Z' class='ci-primary'/>"];

export { cilBookmark };

